<template>
  <div class="vm-audtion bgf5">
    <section class="vm-title-border">
      <div class="vm-title-headline">
        <span>试听课</span>
        <span>百闻不如一见</span>
      </div>
      <div class="vm-title-subhead">任何文字描述不需要课堂真实体验</div>
    </section>
    <section class="vm-audtion-content animated">
      <div class="flex_r_be_c animated">
        <img src="../../../assets/img/k_java.png" class="animated one"/>
        <img src="../../../assets/img/k_html5.png" class="animated two" />
      </div>
      <div class="vm-audition-c">
        <img src="../../../assets/img/k_mysql.png"  />
      </div>
      <div class="flex_r_be_c">
        <img src="../../../assets/img/k_java.png" class="animated four" />
        <img src="../../../assets/img/k_html5.png" class="animated five" />
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import url("../../../assets/css/comm.css");

@import url("../../../assets/css/title.css");
.vm-audtion-content {
  div:not(.vm-audition-c) img{
    width: 49.3%;
    margin-bottom: 10px;
  }
  div:nth-child(2) img {
    width: 100%;
    margin-bottom: 10px;;
    height: 200px;
  }
}
</style>